const getFlagLink = (isd: string) => {
      return `https://purecatamphetamine.github.io/country-flag-icons/3x2/${isd}.svg`
}
export default getFlagLink;